module.exports = __webpack_public_path__ + "img/ApeMale12_Main.87331310.png";